export default "__VITE_ASSET__Mo_r93iY__"